import {useMutation} from "@tanstack/react-query";
import {AutocompleteAddressResponse, UtilsApi} from "@devour/client";

/**
 * useGetAddressAutocomplete
 *
 * Google Places autocomplete for a free-text formatted-address query. Called
 * imperatively per keystroke (not a cached read), so it's a mutation rather than
 * a query. Returns the raw AutocompleteAddressResponse; callers read `.addresses`.
 */
export function useGetAddressAutocomplete() {
    return useMutation<AutocompleteAddressResponse, unknown, string>({
        mutationFn: (formattedAddress: string) =>
            new UtilsApi().getAddressAutocomplete({formattedAddress}),
    });
}
